import { DrEntityAttribute } from './dr-entity-attribute';

export class DrEntity {
    handle: string;
    attributes: Array<DrEntityAttribute>;

    constructor(value?: Partial<DrEntity>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
